import AppChip from './AppChip.vue'

export default AppChip
